module.exports = __webpack_public_path__ + "static/media/IMG_20200207_003829.a47b1d91.jpg";